<template lang="pug">
#graficoTemperatura
    div(v-show='possuiDadosHistoricos')
        apex-charts.component.apexcharts-canvas(
            type='line',
            height='300',
            :options='chartOptions',
            :series='series',
            ref='chart'
        )
    div(v-show='!possuiDadosHistoricos')
        empty-result(
            :min-height='150',
            icon-class='mdi-alert-octagon',
            :message="$t('mensagens.monitoramento.historico.agricola.naoFoiPossivelObterHistoricoDeTemperatura')"
        )
</template>

<script>
import { getGraficoTemperatura } from '@/utils/layouts/graficos';
import EmptyResult from '@/components/EmptyResult';
import ApexCharts from 'vue-apexcharts';

const JANEIRO = 1;
const DEZEMBRO = 12;

export default {
    name: 'GraficoTemperatura',
    components: {
        ApexCharts,
        EmptyResult
    },
    data() {
        return {
            historicoMedias: [],
            series: []
        };
    },

    props: {
        historico: {
            type: Object,
            required: true
        },
        extraOptions: {
            type: Object
        }
    },

    methods: {
        configureDados() {
            const historicoTemperaturaMinima = this.historico.temperaturaMinima;
            const historicoTemperaturaMaxima = this.historico.temperaturaMaxima;

            let historicoTemperaturaMedia = [];
            for (
                let index = 0;
                index < historicoTemperaturaMinima.length;
                index++
            ) {
                let data = { ...historicoTemperaturaMinima[index] };
                data.valor =
                    (historicoTemperaturaMinima[index].valor +
                        historicoTemperaturaMaxima[index].valor) /
                    2;
                historicoTemperaturaMedia.push(data);
            }
            this.historicoMedias = historicoTemperaturaMedia;

            let anos = _.uniq(
                _.map(this.historicoMedias, historico => historico.ano)
            );

            _.each(anos, ano => {
                let dadosAno = _.filter(
                    this.historicoMedias,
                    historico => historico.ano === ano
                );

                this.buildBarSeries(dadosAno, ano);
            });

            this.buildMediaMensal(
                historicoTemperaturaMaxima,
                this.$t('mensagens.monitoramento.historico.agricola.mediaDasTemperaturasMaximas')
            );
            this.buildMediaMensal(
                historicoTemperaturaMinima,
                this.$t('mensagens.monitoramento.historico.agricola.mediaDasTemperaturasMinimas')
            );
        },

        buildBarSeries(dadosAno, ano) {
            let dadosOrdenados = _.orderBy(dadosAno, ['mes'], ['asc']);
            this.series.push({
                name: ano.toString(),
                type: 'column',
                data: _.map(dadosOrdenados, dado => dado.valor)
            });
        },

        buildMediaMensal(historico, nome) {
            let mediasMensais = [];

            for (let i = JANEIRO; i <= DEZEMBRO; i++) {
                let dadosMes = _.filter(historico, h => {
                    return h.mes === i;
                });

                let mediaMensal = _.meanBy(dadosMes, dado => dado.valor);

                mediasMensais.push(mediaMensal);
            }

            this.series.push({
                name: nome,
                type: 'line',
                data: mediasMensais
            });
        }
    },

    computed: {
        possuiDadosHistoricos() {
            const temTemperaturaMaxima = this.historico && this.historico.temperaturaMaxima.length > 0;
            const temTemperaturaMinima = this.historico && this.historico.temperaturaMinima.length > 0;

            return temTemperaturaMaxima && temTemperaturaMinima;
        },

        chartOptions() {
            const baseOptions = getGraficoTemperatura();
            return this.extraOptions ? Object.assign({}, baseOptions, this.extraOptions) : baseOptions;
        }
    },

    mounted() {
        this.configureDados();
    }
};
</script>

<style>
.apexcharts-tooltip {
    background-color: white;
    border: 1px solid #e3e3e3;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
    border-radius: 5px;
    padding: 5px;
}

.apexcharts-tooltip .apexcharts-tooltip-title {
    background: #fff !important;
    align-self: flex-start;
    font-family: Arial, Helvetica, sans-serif;
    color: #333;
    border-bottom: 0px !important;
    font-weight: 600;
    font-size: 14px !important;
    padding: 5px;
    border-radius: 5px 5px 0 0;
}

.apexcharts-tooltip .apexcharts-tooltip-series-group {
    padding: 5px;
    display: flex;
    align-items: center;
}

.apexcharts-tooltip .apexcharts-tooltip-marker {
    width: 10px;
    height: 10px;
    margin-right: 5px;
}

.apexcharts-tooltip .apexcharts-tooltip-text {
    font-size: 12px;
    color: #333;
}

.apexcharts-tooltip .apexcharts-tooltip-text-y-label,
.apexcharts-tooltip .apexcharts-tooltip-text-y-value {
    display: inline-block;
}
</style>
